import React, { useState } from 'react'
import { Typography, Row, Col, Input } from 'antd'
import Button from 'components/shared/button'
import { useRouter } from 'next/router'
import { CurrencyIcon, roundToTwo, IswrongInput } from 'shared/util'

const { Title } = Typography

export default function QuickRatioComponent() {
  const router = useRouter()
  const { currency = 'dollar' } = router.query
  const [values, setValues] = useState({
    assets: '',
    liabilities: '',
    inventory: '',
    result: '',
  })
  const [colors, setColors] = useState({
    assets: '#1890ff',
    liabilities: '#1890ff',
    inventory: '#1890ff',
  })

  const handleCalculation = () => {
    if (
      IswrongInput(values.assets) ||
      IswrongInput(values.liabilities) ||
      IswrongInput(values.inventory)
    ) {
      if (IswrongInput(values.assets)) {
        setColors((prevState) => ({
          ...prevState,
          assets: '#ff00008a',
        }))
      }
      if (IswrongInput(values.liabilities)) {
        setColors((prevState) => ({
          ...prevState,
          liabilities: '#ff00008a',
        }))
      }
      if (IswrongInput(values.inventory)) {
        setColors((prevState) => ({
          ...prevState,
          inventory: '#ff00008a',
        }))
      }
    } else {
      setValues((prevState) => ({
        ...prevState,
        result: roundToTwo(
          (values.assets - values.inventory) / values.liabilities
        ),
      }))
    }
  }

  const handleChange = (event) => {
    const inputValue = event.target.value
    const targetId = event.target.id

    setValues((prevState) => ({
      ...prevState,
      [targetId]: inputValue,
    }))

    if (IswrongInput(inputValue)) {
      setColors((prevState) => ({
        ...prevState,
        [targetId]: '#ff00008a',
      }))
    } else {
      setColors((prevState) => ({
        ...prevState,
        [targetId]: '#1890ff',
      }))
    }
  }

  return (
    <>
      <Title
        level={4}
        style={{
          height: '22px',
          fontWeight: '600',
          fontSize: '21px',
          lineHeight: '22px',
          alignItems: 'center',
          color: '#000000',
          margin: '16px 0px 16px 0px',
        }}
      >
        Quick Ratio Calculator
      </Title>
      <div>
        <Input
          id="assets"
          placeholder="Input Current Assets"
          onChange={handleChange}
          style={{ width: '256px' }}
          suffix={CurrencyIcon(currency, colors.assets)}
        />
      </div>
      <div>
        <Input
          id="inventory"
          placeholder="Input Current Inventory"
          onChange={handleChange}
          style={{ width: '256px', marginTop: '8px' }}
          suffix={CurrencyIcon(currency, colors.inventory)}
        />
      </div>
      <div>
        <Input
          id="liabilities"
          placeholder="Input Current Liabilities"
          onChange={handleChange}
          style={{ width: '256px', marginTop: '8px' }}
          suffix={CurrencyIcon(currency, colors.liabilities)}
        />
      </div>
      <p>
        <Button
          size="large"
          type="primary"
          style={{ marginTop: '8px' }}
          onClick={handleCalculation}
        >
          Calculate
        </Button>
      </p>
      <Title level={4} style={{ fontSize: '14px', marginTop: '16px' }}>
        Quick Ratio
      </Title>
      <Input
        id="liabilities"
        value={values.result}
        style={{ width: '256px' }}
      />
      <Row>
        <Col span={24} style={{ color: '#595959', fontSize: '13px' }}>
          <Row
            span={24}
            style={{
              margin: '24px auto',
              width: '294px',
            }}
          >
            <Col style={{ width: '82px' }}>Quick Ratio =</Col>
            <Col style={{ width: '212px' }}>
              (Current Assets-Current Inventory)/ Current Liabilities
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}
